import { render, staticRenderFns } from "./FileTypeNotSupported.vue?vue&type=template&id=3d1defee&"
import script from "./FileTypeNotSupported.vue?vue&type=script&lang=js&"
export * from "./FileTypeNotSupported.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports